import { CompactUser } from "../../../../core/CompactModels"


/** Which kind of Percall name: matches PercallMappingKinds on the backend. */
export enum PercallKinds {
    JobType = 1,
    JobSource = 2
}

/** How a Percall name got its job type or source: matches PercallMappingOrigins. */
export enum PercallOrigins {
    None = 0,
    NameMatch = 1,
    DefaultTarget = 2,
    Created = 3,
    Manual = 4
}

/** What a name Percall sends for the first time becomes: matches PercallNewNameActions. */
export enum PercallNewNameActions {
    LeaveEmpty = 0,
    CreateNew = 1,
    MapToDefault = 2
}

export interface PercallMappingItem {
    id?: string
    /** The name as Percall sent it. */
    name?: string
    /** The Rinvox job type or job source it maps to. */
    targetId?: string
    targetName?: string
    /** The job type's group; empty for job sources. */
    targetGroupName?: string
    origin?: PercallOrigins
    mappedByUser?: CompactUser
    mappedAt?: Date
    jobsCount?: number
    lastSeenAt?: Date
    createdAt?: Date
}

export interface PercallMappingTarget {
    id?: string
    name?: string
    groupName?: string
}

export interface PercallNewNameRule {
    action?: PercallNewNameActions
    targetId?: string
    groupId?: string
    modifiedByUser?: CompactUser
    modifiedAt?: Date
}

export interface PercallKindSettings {
    rule: PercallNewNameRule
    mappings: PercallMappingItem[]
    targets: PercallMappingTarget[]
}

export interface PercallSettingsData {
    options: PercallOptions
    jobTypes: PercallKindSettings
    jobSources: PercallKindSettings
    jobTypeGroups: { id: string, name: string }[]
}

/** What a pushed job that repeats an open job becomes: matches PercallDuplicateActions. */
export enum PercallDuplicateActions {
    AcceptAndFlag = 0,
    Accept = 1,
    Refuse = 2
}

/** The account's main Percall settings (top of the page). */
export interface PercallOptions {
    duplicateAction?: PercallDuplicateActions
    /** For a repeat of an open job from a different job source. */
    otherSourceDuplicateAction?: PercallDuplicateActions
    modifiedByUser?: CompactUser
    modifiedAt?: Date
}
